import { SFChangePrivacyApi } from '../../shared/sdk/services/custom/SFChangePrivacy';
import { RequestSavePrivacyDto } from '../../shared/nestjs/gd-only/dto/sf-change-privacies.dto';
import { SfChangePrivaciesApi } from '../../shared/nestjs/gd-only/services/sf-change-privacies.api';
import { Injectable } from '@angular/core';
import { NestApiProvider } from '../../shared/nestjs/nest-api';
import { Storage } from '@ionic/storage';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';

/*
  Generated class for the ChangePrivacyBloc provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/

@Injectable()
export class ChangePrivacyBloc {

  constructor(
    private nestApiProvider: NestApiProvider,
    private sfChangePrivaciesApi: SfChangePrivaciesApi,
    private SFChangePrivacyApi: SFChangePrivacyApi,
    private storage: Storage,
  ) {

  }

  loadAuth(): Promise<any> {
    return new Promise(async (resolve) => {
      try {
        await this.storage.ready();
        const data = JSON.parse(await this.storage.get('SFGoAuth'));
        resolve(data);
      } catch (error) {
        resolve(false);
      }
    })
  }

  getDataPrivacy(companyId: any): Observable<any> {
    return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
      .mergeMap(isGoPathNewExist => {
        if (isGoPathNewExist) {
          return this.sfChangePrivaciesApi.getDataPrivacy()
            .pipe(
              map(param => param.data)
            )
        } else {
          return this.SFChangePrivacyApi.getDataPrivacy({ companyId: companyId })
        }
      })
  }

  /**save data privacy */
  saveDataPrivacy(data: RequestSavePrivacyDto): Observable<any> {
    return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
      .mergeMap(isGoPathNewExist => {
        if (isGoPathNewExist) {
          return this.sfChangePrivaciesApi.savePrivacy(data)
            .pipe(
              map(param => param.data)
            )
        } else {
          return this.SFChangePrivacyApi.savePrivacy(data)
            .pipe(
              map(param => param.success)
            )
        }
      })
  }

}




// WEBPACK FOOTER //
// ./src/bloc/settings/change-privacy.bloc.ts